// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2NlWz","label":"SetPasswdForm_label__pln7z"};